import config from "config";
import {cdnTemplate, jadeLocals} from "cdnPreprocessor";

export default [
  '$stateProvider', '$locationProvider', '$sceDelegateProvider', 'uiMask.ConfigProvider', '$urlRouterProvider',
  function($stateProvider, $locationProvider, $sceDelegateProvider, uiMaskConfigProvider, $urlRouterProvider) {
    $urlRouterProvider.otherwise('/error');

    $stateProvider
      .state('home', { url: '/' })
      .state('contact', { url: '/contact-us' })
      .state('faq', { url: '/faq' })
      .state('about', { url: '/about-us' })
      .state('partnerships', { url: '/partnership' })
      .state('press', { url: '/press' })
      .state('privacy', { url: '/privacy' })
      .state('terms', { url: '/terms' })
      .state('how-it-works', { url: '/how-it-works' })
      .state('features', { url: '/features' })
      .state('unsupported-browser', { url: '/unsupported-browser' })
      .state('careers', { url: '/careers' })
      .state('trending', { url: '/trending' })
      .state('featured', { url: '/featured' })
      .state('login', { url: '/login' })
      .state('register', { url: '/register' })
      .state('forgot-password', { url: '/forgot-password' })

      .state('my-account', {
        abstract: true,
        templateUrl: cdnTemplate('/my-account.html'),
        url: '/my-account'
      })
      .state('my-account.order-history', {
        url: '',
        controller: 'OrderHistoryCtrl as history',
        templateUrl: cdnTemplate('/order-history.html')
      })
      .state('my-account.default-address', {
        url: '/default-address',
        controller: 'DefaultAddressCtrl as default',
        templateUrl: cdnTemplate('/default-address.html')
      })
      .state('my-account.payment-methods', {
        url: '/payment-methods',
        controller: 'PaymentMethodsCtrl as payment',
        templateUrl: cdnTemplate('/payment-methods.html')
      })
      .state('password-reset', {
        url: '/password-reset/{token}'
      })
      .state('track-order', {
        templateUrl: cdnTemplate('/track-order.html'),
        controller: 'TrackOrderCtrl as trackOrder',
        url: '/track-order'
      })
      .state('order-summary', {
        templateUrl: cdnTemplate('/order-summary.html'),
        controller: 'OrderSummaryCtrl as summary',
        url: '/order-summary?order_num&zip&ca',
        params: {
          order: null,
          order_num: null,
          zip: null,
          ca: null
        }
      })
      .state('client-store', {
        controller: 'ClientStoreCtrl as client',
        url: '/store/{publicName}/{storeName}?coupon',
        templateUrl: cdnTemplate('/client-store.html')
      })
      .state('checkout', {
        controller: 'CheckoutCtrl as checkout',
        url: '/purchase/checkout?pn&sl',
        templateUrl: cdnTemplate('/checkout.html'),
        params: {
          'pn': null,
          'sl': null
        }
      })
      .state('amazon-checkout', {
        controller: 'AmazonCheckoutCtrl as checkout',
        url: '/purchase/amazon-checkout?id&session&csl',
        templateUrl: cdnTemplate('/amazon-checkout.html'),
        params: {
          'id': '',
          'session': '',
          'upsell': false,
          'upsellProduct': null,
          'username': null,
          'campaign': null,
          'csl': ''
        },
        resolve: {
          username: ['$stateParams', function($stateParams) {
            return $stateParams.username;
          }],
          campaignSlug: ['$stateParams', function($stateParams) {
            return $stateParams.campaign;
          }]
        }
      })
      .state('paypal-checkout', {
        controller: 'PayPalCheckoutCtrl as checkout',
        url: '/purchase/paypal-checkout?pn&sl&upsell',
        templateUrl: cdnTemplate('/paypal-checkout.html'),
        params: {
          'pn': null,
          'sl': null,
          'upsell': 'false'
        }
      })
      .state('thank-you', {
        controller: 'ThankYouCtrl as thankYou',
        url: '/purchase/thank-you?order_num&zip?paymentId?PayerID',
        params: {
          'order_num': null,
          'zip': null,
          'paymentId': null,
          'PayerID': null,
          'username': null,
          'campaign': null,
          // 'password': null
        },
        templateUrl: cdnTemplate('/thank-you.html'),
        resolve: {
          username: ['$stateParams', function($stateParams) {
            return $stateParams.username;
          }],
          campaignSlug: ['$stateParams', function($stateParams) {
            return $stateParams.campaign;
          }]
        }
      })
      .state('sales-store', {
        url: '/:username/:campaignSlug?coupon&opt_out',
        template: require('pages/store/store.jade')(jadeLocals),
        controller: 'StoreCtrl as store',
        resolve: {
          username: ['$stateParams', function($stateParams) {
            return $stateParams.username;
          }],
          campaignSlug: ['$stateParams', function($stateParams) {
            return $stateParams.campaignSlug;
          }]
        }
      })
      .state('error', { url: '/error' });

    $locationProvider.html5Mode({
      enabled: true,
      rewriteLinks: false
    });

    $.ajaxSetup({
      cache: true
    });

    let whitelist = ['self'];
    if (config['Environment'] === 'Production') {
      whitelist.push(`https://a.${config['TemplatesUrl']}/**`);
      whitelist.push(`https://b.${config['TemplatesUrl']}/**`);
      whitelist.push(`https://c.${config['TemplatesUrl']}/**`);
    }
    if (config['Environment'] === 'Staging') {
      whitelist.push(`https://dev-a.${config['TemplatesUrl']}/**`);
      whitelist.push(`https://dev-b.${config['TemplatesUrl']}/**`);
      whitelist.push(`https://dev-c.${config['TemplatesUrl']}/**`);
    }

    $sceDelegateProvider.resourceUrlWhitelist(whitelist);

    uiMaskConfigProvider.clearOnBlur(false);
    uiMaskConfigProvider.allowInvalidValue(true);
  }
];


// WEBPACK FOOTER //
// ./source/client/cui-routes.js